export const getDate = ({ format = '%Y-%m-%d', addDays = 0 } = {}) => {
  let date = new Date()
  if (addDays !== 0) {
    date.setDate(date.getDate() + addDays)
  }

  let d = {
    year: date.getFullYear(),
    month: date.getMonth(),
    day: date.getDate(),
    hours: date.getHours(),
    minutes: date.getMinutes()
  }
  let dateTex = format.replace('%Y', d.year)
    .replace('%m', (d.month + 1 < 10 ? '0' : '') + (d.month + 1))
    .replace('%d', (d.day < 10 ? '0' : '') + d.day)
    .replace('%H', (d.hours < 10 ? '0' : '') + d.hours)
    .replace('%i', (d.minutes < 10 ? '0' : '') + d.minutes)

  return dateTex
}